export const columnsDataComplex = [
  {
    Header: "EVENT",
    accessor: "eventName",
  },
  {
    Header: "INSTALLS",
    accessor: "installs",
  },
  {
    Header: "D0",
    accessor: "eventsD0",
  },
  {
    Header: "D1",
    accessor: "eventsD1",
  },
  {
    Header: "D3",
    accessor: "eventsD3",
  },
  {
    Header: "D7",
    accessor: "eventsD7",
  },
  {
    Header: "D14",
    accessor: "eventsD14",
  },
  {
    Header: "D30",
    accessor: "eventsD30",
  },
  {
    Header: "D60",
    accessor: "eventsD60",
  },
  {
    Header: "To Date",
    accessor: "eventsD180",
  },
];
